import { useParams } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import {
    FaEye,
    FaEyeSlash,
    FaCheckCircle,
    FaTimesCircle,
    FaLock
} from "react-icons/fa";

export default function ResetPassword() {
    const { token } = useParams();

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState(""); // success | error
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            setStatus("error");
            setMessage("Passwords do not match");
            return;
        }

        try {
            setLoading(true);
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}/reset-password`,
                { token, password }
            );

            if (res.data.status) {
                setStatus("success");
                setMessage("Password reset successfully");

                setTimeout(() => {
                    window.location.href = "/#/";
                }, 2000);
            }
        } catch {
            setStatus("error");
            setMessage("Reset link expired or already used.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <div style={styles.iconWrap}>
                    <FaLock size={28} />
                </div>

                <h2 style={styles.title}>Reset Password</h2>
                <p style={styles.subtitle}>Create a new secure password</p>

                {/* Status */}
                {message && (
                    <div
                        style={{
                            ...styles.alert,
                            background: status === "success" ? "#e6fffa" : "#ffe6e6",
                            color: status === "success" ? "#0f766e" : "#b91c1c"
                        }}
                    >
                        {status === "success" ? <FaCheckCircle /> : <FaTimesCircle />}
                        <span>{message}</span>
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    {/* New Password */}
                    <div style={styles.inputGroup}>
                        <FaLock style={styles.inputIcon} />
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder="New password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={styles.input}
                        />
                        <span onClick={() => setShowPassword(!showPassword)} style={styles.eye}>
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                    </div>

                    {/* Confirm Password */}
                    <div style={styles.inputGroup}>
                        <FaLock style={styles.inputIcon} />
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Confirm password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            style={styles.input}
                        />
                        <span onClick={() => setShowConfirmPassword(!showConfirmPassword)} style={styles.eye}>
                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            ...styles.button,
                            opacity: loading ? 0.7 : 1
                        }}
                    >
                        {loading ? "Updating..." : "Reset Password"}
                    </button>
                </form>
            </div>
        </div>
    );
}
const styles = {
    page: {
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #667eea, #764ba2)"
    },
    card: {
        width: 380,
        padding: 30,
        borderRadius: 16,
        background: "#fff",
        boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
        textAlign: "center"
    },
    iconWrap: {
        width: 56,
        height: 56,
        borderRadius: "50%",
        background: "#4f46e5",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 15px"
    },
    title: {
        marginBottom: 4
    },
    subtitle: {
        color: "#6b7280",
        fontSize: 14,
        marginBottom: 20
    },
    alert: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: 10,
        borderRadius: 8,
        marginBottom: 15,
        fontSize: 14
    },
    inputGroup: {
        position: "relative",
        marginBottom: 15
    },
    inputIcon: {
        position: "absolute",
        left: 12,
        top: 12,
        color: "#9ca3af"
    },
    input: {
        width: "100%",
        padding: "12px 40px 12px 38px",
        borderRadius: 10,
        border: "1px solid #d1d5db",
        outline: "none",
        fontSize: 14
    },
    eye: {
        position: "absolute",
        right: 12,
        top: 12,
        cursor: "pointer",
        color: "#6b7280"
    },
    button: {
        width: "100%",
        padding: 12,
        borderRadius: 10,
        border: "none",
        background: "#4f46e5",
        color: "#fff",
        fontSize: 15,
        fontWeight: 600,
        cursor: "pointer",
        marginTop: 10
    }
};
